import React, { useState, useEffect } from 'react';

function FilterDialog({
  open,
  onClose,
  onApply,
  filters,
  publications,
  sites,
  tags,
  title = 'Filter Ceramics'
}) {
  const [localFilters, setLocalFilters] = useState({});

  useEffect(() => {
    if (open) {
      setLocalFilters({ ...filters });
    }
  }, [open, filters]);

  if (!open) return null;

  const handleApply = () => {
    onApply(localFilters);
    onClose();
  };

  const handleClear = () => {
    setLocalFilters({});
  };

  const activeFilterCount = Object.values(localFilters).filter(
    (v) => v !== '' && v !== null && v !== undefined
  ).length;

  return (
    <>
      <div className="filter-dialog__overlay" onClick={onClose} />
      <div className="filter-dialog">
        <div className="filter-dialog__header">
          <h3>{title}</h3>
          <button className="filter-dialog__close" onClick={onClose} aria-label="Close">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path
                d="M15 5L5 15M5 5l10 10"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
          </button>
        </div>

        <div className="filter-dialog__body">
          <div className="filter-dialog__field">
            <label className="filter-dialog__label" htmlFor="filter-publication">
              Publication
            </label>
            <select
              id="filter-publication"
              className="filter-dialog__select"
              value={localFilters.publicationId || ''}
              onChange={(e) =>
                setLocalFilters((prev) => ({ ...prev, publicationId: e.target.value }))
              }
            >
              <option value="">All Publications</option>
              {publications.map((p) => (
                <option key={p.id} value={p.id}>
                  {p.label ?? p.title ?? p.name}
                </option>
              ))}
            </select>
          </div>

          <div className="filter-dialog__field">
            <label className="filter-dialog__label" htmlFor="filter-site">
              Site
            </label>
            <select
              id="filter-site"
              className="filter-dialog__select"
              value={localFilters.siteId || ''}
              onChange={(e) => setLocalFilters((prev) => ({ ...prev, siteId: e.target.value }))}
            >
              <option value="">All Sites</option>
              {sites.map((s) => (
                <option key={s.id} value={s.id}>
                  {s.name}
                </option>
              ))}
            </select>
          </div>

          <div className="filter-dialog__field">
            <label className="filter-dialog__label" htmlFor="filter-tags">
              Tags
            </label>
            <select
              id="filter-tags"
              className="filter-dialog__select"
              multiple
              value={Array.isArray(localFilters.tagIds) ? localFilters.tagIds : []}
              onChange={(e) => {
                const selected = Array.from(e.target.selectedOptions).map((o) => o.value);
                setLocalFilters((prev) => ({ ...prev, tagIds: selected }));
              }}
            >
              {tags.map((t) => (
                <option key={t.id} value={t.id}>
                  {t.name}
                </option>
              ))}
            </select>
            <p className="filter-dialog__help">Hold Ctrl/Cmd to select multiple tags</p>
          </div>

          <div className="filter-dialog__field">
            <label className="filter-dialog__label" htmlFor="filter-verified">
              Verified
            </label>
            <select
              id="filter-verified"
              className="filter-dialog__select"
              value={localFilters.verified ?? ''}
              onChange={(e) =>
                setLocalFilters((prev) => ({ ...prev, verified: e.target.value || null }))
              }
            >
              <option value="">All</option>
              <option value="true">Verified</option>
              <option value="false">Not Verified</option>
            </select>
          </div>
        </div>

        <div className="filter-dialog__footer">
          <button className="btn btn-secondary" onClick={handleClear}>
            Clear
          </button>
          <div className="filter-dialog__actions">
            <button className="btn btn-ghost" onClick={onClose}>
              Cancel
            </button>
            <button className="btn btn-primary" onClick={handleApply}>
              Apply
              {activeFilterCount > 0 && (
                <span className="filter-dialog__badge">{activeFilterCount}</span>
              )}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default FilterDialog;
